import { useState } from "react";
import { PhysShell, Field, ResultCard, Stat, primaryBtn } from "./PhysShell.jsx";
import { ohms, round } from "./physcore.js";

export default function Ohms() {
  const [V, setV] = useState("");
  const [I, setI] = useState("2");
  const [R, setR] = useState("5");
  const [res, setRes] = useState(null);

  const go = () => {
    const p = (x) => (x.trim() === "" ? null : parseFloat(x));
    setRes(ohms({ V: p(V), I: p(I), R: p(R) }));
  };

  return (
    <PhysShell title="Ohm's Law">
      <p style={{ fontSize: 13, color: "#5B5E7A", marginTop: 0 }}>
        V = IR. Fill two, leave the unknown blank. Power computed too.
      </p>
      <Field label="Voltage V" suffix="V" value={V} onChange={(e) => setV(e.target.value)} placeholder="—" />
      <Field label="Current I" suffix="A" value={I} onChange={(e) => setI(e.target.value)} placeholder="—" />
      <Field label="Resistance R" suffix="Ω" value={R} onChange={(e) => setR(e.target.value)} placeholder="—" />
      <button onClick={go} style={primaryBtn}>Solve</button>
      {res && !res.ok && <ResultCard><span style={{ color: "#F8716A" }}>{res.error}</span></ResultCard>}
      {res && res.ok && (
        <ResultCard>
          <Stat label="Voltage V" value={round(res.result.V, 4)} unit="V" />
          <Stat label="Current I" value={round(res.result.I, 4)} unit="A" />
          <Stat label="Resistance R" value={round(res.result.R, 4)} unit="Ω" />
          <Stat label="Power P" value={round(res.result.P, 4)} unit="W" />
          <div style={{ marginTop: 12, fontSize: 13, color: "#9A9DBE" }}>Used: {res.formula}</div>
          {(() => {
            const blank = V === "" ? "V" : I === "" ? "I" : R === "" ? "R" : null;
            if (!blank) return null;
            const r = res.result;
            const sub =
              blank === "V" ? `V = I·R = ${round(r.I,4)} × ${round(r.R,4)} = ${round(r.V,4)} V`
              : blank === "I" ? `I = V/R = ${round(r.V,4)} / ${round(r.R,4)} = ${round(r.I,4)} A`
              : `R = V/I = ${round(r.V,4)} / ${round(r.I,4)} = ${round(r.R,4)} Ω`;
            return (
              <div style={{ marginTop: 8, fontSize: 12.5, color: "#C8CADF", fontFamily: "ui-monospace, monospace" }}>
                Solved for {blank}:  {sub}
              </div>
            );
          })()}
        </ResultCard>
      )}
    </PhysShell>
  );
}

